const config = {
    title: 'Starhub TV+',
    client: 'starhub',
    clientName: 'StarHub 2024',
    defaultLocale: 'en',
    supportedLanguages: ['en', 'zh'],
    rtlLanguages: ['he', 'ar'],
    authenticationType: 'oauth',
    authenticationTypeQr: 'device',
    subscriptionUrl: 'https://links.starhub.com/Wkp6/TV',
    isNewRelicDisabled: false,
    isAdsEnabled: true,
    searchLeft: false,
    needRedemptionCodeFormat: false,
    redemptionCodeFormat: /^\w{4}-\w{4}-\w{4}-\w{4}$/gm,
    redemptionCodePlaceholder: "XXXX-XXXX-XXXX-XXXX",
    recordingMessage: 'web',
    epg: {
        numOfDaysFuture: 7,
        numOfDaysPast: 1,
        adjustTitlesInView: true
    },
    emiModules: {
        home: {
            isEMIUniverse: true,
            name: 'home',
        },
        vod: {
            isEMIUniverse: true,
            name: 'vod',
        },
        offer: {
            isEMIUniverse: true,
            name: 'offer',
        },
        sport: {
            isEMIUniverse: true,
            name: 'sport',
        },
        theme: {
            isEMIUniverse: false,
            name: 'theme',
        },
    },
    relatedTypes: {
        vod: ['vod', 'live'],
        live: ['live', 'vod'],
    },
    bootRequests: {
        lastChannelsLcn: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        recordings: {
            requestAtBoot: true,
            waitAtBoot: false,
        },
        recordingsFavorites: {
            requestAtBoot: true,
            waitAtBoot: false,
        },
        reminders: {
            requestAtBoot: true,
            waitAtBoot: false,
        },
        continueWatching: {
            requestAtBoot: true,
            waitAtBoot: false,
        },
        channelApps: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        products: {
            requestAtBoot: true,
            waitAtBoot: true,
        },
        liveNow: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        vodNodes: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        recommendation: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        vodFavorites: {
            requestAtBoot: true,
            waitAtBoot: false,
        },
        channels: {
            requestAtBoot: true,
            waitAtBoot: true,
        },
        mostWatched: {
            requestAtBoot: true,
            waitAtBoot: false,
        },
    },
    // universes: [
    //     'root-coach',
    //     'root-epg',
    //     'root-sport',
    //     'root-vod',
    //     'root-offer',
    //     'root-settings',
    //     'root-search',
    //     'root-logout',
    // ],
    enableMaculosaSearch: true,
    forgotParentalPinType: "email",
    forgotR21PinType: "email", //email or message
    audioLanguages: ['default', 'en', 'zh-HANS', 'zh-HANT', 'ja', 'ko', 'ms', 'ta'],
    subtitleLanguages: ['default', 'off', 'en', 'zh-HANS', 'zh-HANT', 'ja', 'ko', 'ms', 'ta'],
    defaultAudioLocale: 'default',
    defaultSubtitleLocale: 'default',
    purchaseAuthType: 'PARENTAL_PIN', 
    showQRforSubscription: true,
    showDollerForRentSubscription: true,

    userAuthType: "BOTH", //QR, LOGIN, BOTH
    allowLoginWithSecureId: false, // only for stb

    searchContentTypes: ['VOD', 'EPG_LIVE', 'EPG_PAST', 'EPG_FUTURE', 'CHANNEL'],
    localSearchContentTypes: ['VOD', 'EPG_LIVE', 'EPG_PAST', 'EPG_FUTURE', 'CHANNEL'],
    forgotPasswordQr : 'https://login.starhubgee.com.sg/sso/ForgetPassword',
    forgotPassword: true,
    nagra: {
        tenantId: 'nagra',
        metadataProvider: 'GLOBAL',
        rollingBufferDuration: 24,
        fetchOnlySubscribedProducts: false,
        useTokenization: true,
    },
    
    // For analytics, enable public ip service
    publicIpService: {
        enabled: true,
        provider: 'ipify',
        providerUrl: 'https://api.ipify.org?format=json',
    },

    voltPlayer: {
        drmConfig: {
            system: 'nagra-ssp',
            tenantId: 'SCVM1SC0',
            widevineLicenseUrl: 'https://scvm1sc0.anycast.nagra.com',
            SSMLicenseUrl: 'https://scvm1sc0-ssm.anycast.nagra.com/SCVM1SC0/ssm',
        },
        mediaEngine: 'nagra',
    },
    hasPortalScreen: true,
    emiModulesToUniverseRoot: {
        root: 'root',
        home: 'root-coach',
        vod: 'root-vod',
        sport: 'root-sport',
        recordings: 'root-recordings',
        // offer: 'root-offer',
        offer: 'root-packages'
    },

    universeRootToEMIModule: {
        root: 'root',
        'root-coach': 'home',
        'root-vod': 'vod',
        'root-sport': 'sport',
        // 'root-offer': 'offer',
        'root-packages': 'offer'
    },
    enableGenresFilterNode: true,
    enableMultiLocalesMetadatas: true,
    contentNodePageSize: 3,
    emiScreenAliases: {
        "home": "root-coach",
        "vod":"root-vod",
        "guide": "root-epg",
        "premier-league": "root-sport",
        "store": "root-packages",
        "recordings": "root-recordings"
    },
    screenPathAliases: {
        "root-coach": "home",
        "root-vod": "vod",
        "root-epg": "guide",
        "root-sport": "premier-league",
        "root-packages": "store",
        "root-recordings": "recordings"
    },
    // show apps added in EMI requests
    showApps: true,

    // EMI provides layout/format info for items/rows
    supportedLayoutsFromEMi: ['vod', 'predefined', 'app'],

    // MAC-638 - default node ordering in descending order pending feature from EMI
    proxy: {
        defaultNodeOrdering: 'node_pos_desc',
        defaultCategoryOrdering: 'node_pos_desc', // Hack as feature not support by EMI and starhub very demanding
        enableFetchProductTitles: false,
    },
    customErrorMsg: {
        MAX_DEVICES_REACHED: {
            title: 'PBL-212-Max-Device-Reached',
            description:
                'Maximum permissible device count for your account reached. Please, manage device count from your other device ( like STB)',
            subDescription: '',
        },
        RECORDING_NO_QUOTA_SUBSCRIPTION :{
            title:"RECORDING_NO_QUOTA_SUBSCRIPTION",
            description: "noRecordingQuota",
            subDescription: 'noRecordingQuota'
            
        }
    },
    epgGrid: {
        flatEpg: false, // flat or classic grid
        epgFlatDefaultSlotDurationMin: 30, // half hour
        epgVisibleSlots: 5, // N slots visible in EPG
        epgVisibleLineCount: 7, // number of visible line in flat EPG
        epgMaxConcurrentRequests: 3,
        epgPrefetchBatchSize: 20, // The number of prefetched channels in the EPG (current day only)
        epgHorizontalDurationHours: 4,
        epgPlaceHolderDuration: 2, // in hours
    },
    epgChannelsBatchSize: 15,
    menuTranslationFromLocal: true,

    //Display content title or Watch button flag
    heroSliderTitleDisplay: false,
    MAX_DEVICES_REACHED: {
        title: 'PBL-212-Max-Device-Reached',
        description:
            'Maximum permissible device count for your account reached. Please, manage device count from your other device ( like STB)',
        subDescription: '',
    },
    // Dynamic Content FIREBASE_COMMON_CONFIG
    analytics: {
        // This configuration allowyou to disable Analytics
        disabled: false,
        // This value force to get user consent beforce enabling Analytics.
        // Not required for all country (Example: Required in US/Europe, not really in Asia)
        // UI to be implemented for getting user consent
        userConsentRequired: false,
        // For device sampling, percentage of devices allowed for analytics
        percentageEnabled: 100,
        // Force User Personnal data collection even if user did not provide his consent
        forcePersonalUserDataCollection: true,
        // Session of analytics. By default 30 minutes before closing a session
        // sessionDurationMs: 30 * 60 * 1000,
        // Define the list of supported event (Native and Custom)
        supportedEvents: [
            // -- Events enabled by default --
            'screen',
            'login',
            'sign_up',
            'app_open',
            'starter_kit',
            'select_content',
            'purchase',
            'search',
            // --- Custom Events ---
            'bootstrap_data',
            'logout',
            'unsubscribe',
            'activate_subscription',
            'playback_start',
            'playback_pause',
            'playback_resume',
            'playback_stop',
            'playback_error',
            'emi',
            // Additionnal errors from the UI
            'app_error',
            'app_start',
            'favorites_add_content',
            'favorites_remove_content',
            'add_reminder',
            'remove_reminder',
            'setting_update_parental_control',
            'setting_update_pin',
            'setting_reset_pin',
            'setting_update_password',
        ],
        firebaseScreen: {
            SEARCH: 'SEARCH',
            EPG: 'EPG',
            WALL: 'WALL_VIEW',
            PLAYBACK: 'PLAYBACK_FULLSCREEN',
            SETTINGS: 'SETTINGS',
            DETAILS: 'DETAIL_VIEW',
        },
        forceDoubleDataType: true
    },
    theme: {
        focusColor: '#03F182',
        focusTextColor: '#12171B',
        textColor: '#EEEEEE',
        backgroundColor: '#12171B',
        secondaryBackgroundColor: '#21262A',
        backgroundBlurColor: '#21262A80',
        interactiveBackgroundColor: '#EEEEEE1A',
        primaryBackgroundColor: '#12171B',
        fontFamily: 'Lato',
        kidsIconFocusColor:'#E52B50',
        kidsIconFocusTextColor:'#EEEEEE'
    },
    navigationMenuIgnoreList: ['root-offer', 'root-replay'],
    guestModeMenuIgnoreList: ['root-recordings', 'root-packages', 'root-offer', 'root-replay'],
    pcLevels: {
        UNRATED: 0,
        G: 0,
        PG: 1,
        PG13: 12,
        NC16: 15,
        'RATED 16': 15,
        M18: 17,
        'RATED 18': 17,
        Disabled: 18,
        R21: 20,
    },

    // Special rating level for which censorship pin is needed rather than adult pin
    censoredLevel: 20,

    bootLogo: false,

    // userPcLevels and content pcLevels (see above) are not the same.
    // You'll find below a map associating each userPcLevel with a label.
    // Not in volt-trad as it's very client specific
    userPcLevels: [
        {
            title: { en: 'R21', zh: 'R21' },
            description: {
                en:
                    'Restricted to persons aged 21 and above. (R21 PIN is always required to watch such content.)',
                zh: '僅限 21 歲及以上人士。（觀看此類內容始終需要 R21 PIN 碼。',
            },
            level: 20,
            isCensored: true,
        },
        {
            title: { en: 'M18', zh: 'M18' },
            description: {
                en: 'Restricted to persons aged 18 and above',
                zh: '僅限 18 歲及以上人士',
            },
            level: 17,
        },
        {
            title: { en: 'NC16', zh: 'NC16' },
            description: {
                en: 'Restricted to persons aged 16 and above',
                zh: '只限16歲及以上人士參加',
            },
            level: 15,
        },
        {
            title: { en: 'PG13', zh: 'PG13' },
            description: {
                en:
                    'Suitable for persons aged 13 and above, but parental guidance is advised for children below 13.',
                zh: '適合 13 歲及以上人士，但建議 13 歲以下兒童在家長指導下進行。',
            },
            level: 12,
        },
        {
            title: { en: 'PG', zh: 'PG' },
            description: {
                en:
                    'Suitable for persons of all ages but parental guidance is recommended for younger viewers.',
                zh: '適合所有年齡段的人，但建議年輕觀眾在家長的指導下觀看。',
            },
            level: 1,
        },
        {
            title: { en: 'G - General', zh: 'G - General' },
            description: {
                en: 'Suitable for personals of all ages',
                zh: '適合所有年齡段的人',
            },
            level: 0,
        },
        // This rating does not exist it is a Hack for simulation a disable functionnality
        {
            title: { en: 'Disabled', zh: 'Disabled' },
            description: {
                en: 'Note: If "Disabled" is not selected, Parental Control PIN will be required when making purchases in the application ',
                zh: '注意:如果未选择“禁用“，则在应用程序中进行购买时将需要输入家长密码。',
            },
            level: 19,
        },
    ],
    settings: [{
        title: "SETTINGS",
        haveChildren: true,
        disabled: false,
        id: 'mainSettings',
        childrens: [
            {
                title: "SETTINGS_TITLE",
                id: "tvAppSettings",
                detailTitle: "",
                haveChildren: true,
                disabled: false,
                childrens: [
                    {
                        title: "OVERSCAN",
                        disabled: true,
                        id: "overscan",
                        haveChildren: false
                    },
                    {
                        title: "MENU_LANGUAGE",
                        disabled: false,
                        id: "menulanguage",
                        haveChildren: false
                    },
                    {
                        title: "DEFAULT_AUDIO_LANGUAGE_TITLE",
                        disabled: false,
                        id: "audiotitleLanguage",
                        haveChildren: false
                    },
                    {
                        title: "DEFAULT_SUBTITLE_LANGUAGE_TITLE",
                        disabled: false,
                        id: "subtitleLanguage",
                        haveChildren: false
                    },
                    {
                        title: "CHANNEL_FILTERING",
                        disabled: true,
                        id: "channelFiltering",
                        haveChildren: false
                    },
                    {
                        title: "POWER_MANAGEMENT",
                        disabled: true,
                        id: "powerManagement",
                        haveChildren: false
                    },
                    {
                        title: "TERMS_N_CONDITIONS",
                        disabled: false,
                        id: "termsconditions",
                        haveChildren: false
                    },
                    {
                        title: "HELP_AND_FAQ",
                        disabled: false,
                        id: "helpfaqs",
                        haveChildren: false
                    },
                    {
                        title: "REPORT_VULNERABILITY",
                        disabled: false,
                        id: "reportVulnerability",
                        haveChildren: false
                    },
                    {
                        title: "LOG_OUT",
                        disabled: false,
                        id: "logOut",
                        haveChildren: false
                    },
                ]
            },
            {
                title: "USER_SETTINGS",
                id: "USER_SETTINGS",
                detailTitle: "",
                haveChildren: true,
                disabled: false,
                childrens: [
                    {
                        title: "ACCOUNT",
                        disabled: false,
                        id: "accountInfo",
                        haveChildren: false
                    },
                    {
                        title: "TRANSACTION_HISTORY",
                        disabled: false,
                        id: "transactionlist",
                        haveChildren: false
                    },
                    {
                        title: "PARENTAL_LEVEL",
                        disabled: false,
                        id: "parentalLevel"
                    },
                    {
                        title: "PARENTAL_CODE",
                        disabled: false,
                        id: "parentalCode"
                    },
                    {
                        title: "RESET_PARENTAL_CODE",
                        disabled: true,
                        id: "resetParentalCode"
                    },
                    {
                        title: "RESET_PARENTAL_CODE",
                        disabled: false,
                        id: "resetParentalCodeConfirm"
                    },
                    {
                        title: "R21_PIN",
                        disabled: false,
                        id: "r21code"
                    },
                    {
                        title: "RESTRICT_BY_CHANNEL",
                        disabled: false,
                        id: "restrictedByChannel"
                    },
                    {
                        title: "REDEMPTION_CODE",
                        disabled: false,
                        id: "redemptionCode"
                    },
                    {
                        title: "DEVICE_MANAGEMENT",
                        disabled: false,
                        id: "deviceManagement",
                        haveChildren: false
                    },
                    {
                        title: "CHANNEL_FILTERING",
                        disabled: true,
                        id: "channelFiltering",
                        haveChildren: false
                    }
                ]
            },
            {
                title: 'MY_ACCOUNT_DETAILS',
                id: "myAccountDetails",
                detailTitle: "",
                haveChildren: false,
                disabled: false,
            },
            {
                title: "ENVIRONMENT",
                detailTitle: "",
                disabled: false,
                id: "enviroment",
                haveChildren: true,
                childrens: [
                    {
                        title: "PRODUCTION",
                        disabled: false,
                        id: "production"
                    },
                    {
                        title: "PREPRODUCTION",
                        disabled: false,
                        id: "preproduction"
                    },
                    {
                        title: "INTERNALPROD",
                        disabled: false,
                        id: "internalproduction"
                    },
                    {
                        title: "STAGING",
                        disabled: false,
                        id: "staging"
                    },
                    {
                        title: "QA",
                        disabled: false,
                        id: "qa"
                    },
                    {
                        title: "DEVELOPEMENT",
                        disabled: false,
                        id: "development"
                    }
                ]
            }
        ]
    }
    ],
    displayR21Pin: true,
    defaultUserPcLevel: 19,
    adultRating: 'X18',
    disable_R21_option:true,
    toastQRCodeLink:'https://starhub.com/personal/tvplus/add-ons',
    posterRatio: '2/3',
    landscapeRatio: '16/9',
    conviva: {
        enable: true,
        customerKey: 'ce72c24b6cec8e868419d5093b7822a11707ae42',
        gatewayUrl: 'https://ce72c24b6cec8e868419d5093b7822a11707ae42.ts-testonly.conviva.com',
        logLevel: 0,
        applicationName: 'webStv',
    },
    showAccountTab: true,
    manageSubscription : true,
    purchasePanelLegacyUI : false,
    userPcLevelSort: true,
    emailID : "HUB ID:",
    customerId : "TVID:",
    heroSliderAutoplayDuration : 5000,
    showExitPopup: false,
    subscriptionLink: 'https://links.starhub.com/Wkp6/TV',
    isRestrictedContent: {
        blurHeroBanner:true,
        showParentalRating:true,
    },
    accountDetails: {
        displayRestartButton: true,
        hiddenFields: [
            'accountId',
            'accountNumber',
            'deviceName',
            'connectionType',
            'connectionQuality',
            'population',
        ],
    },
    askParentalOnResume: true,
    displaySeriesRecommendation: false, // Disabled as requested from Starhub
    displayMovieRecommendation: true,
}

export default config
